import get from 'lodash/get';

import { pairAuthFlows } from 'src/common/constants/auth/oauth';
import { SUBSCRIBE_PAIR_PATH } from 'src/common/constants/paths';
import { PAIR_AUTH_FLOW, USER_CODE } from 'src/common/constants/queryParams';
import { selectProductFromQuery } from 'src/common/utils/subscription/findProductHelpers';
import hasNeverSubscribedOnWeb from 'src/common/utils/subscription/hasNeverSubscribedOnWeb';

export function getPairAuthFlowParam(query) {
  return get(query, PAIR_AUTH_FLOW);
}

export function getUserCodeParam(query) {
  return get(query, USER_CODE);
}

export function hasPairAuthFlowParam(query) {
  return !!getPairAuthFlowParam(query);
}

export function isPairAuthFlowPin(query) {
  const pairAuthFlowParam = getPairAuthFlowParam(query);

  return !!(pairAuthFlowParam && pairAuthFlowParam === pairAuthFlows.pin);
}

export function isSubscribePairPath(pathname) {
  return pathname === SUBSCRIBE_PAIR_PATH;
}

/**
 * Checks if we should send user to /subscribepair page (CC Input Page in pairing Flow)
 * Returns true if user's account is eligible to sign up for a new web subscription
 * && A/B test isSubscriptionEnabled set to true
 * && their product sku supports /subscribepair
 * @param location {object}
 * @param isSubcribePairingEnabled {boolean}
 * @param products {object}
 * @param userDetails {object}
 *
 */
export function shouldSendToSubscribePair(
  location,
  isSubscriptionEnabled,
  products,
  userDetails,
) {
  const selectedProduct = selectProductFromQuery(products, location);
  const isUserWebSubscriptionEligible = hasNeverSubscribedOnWeb({
    details: userDetails,
  });

  return (
    isUserWebSubscriptionEligible &&
    isSubscriptionEnabled &&
    !!selectedProduct?.sku
  );
}
